import { render, staticRenderFns } from "./Updated.vue?vue&type=template&id=3a7f97de&"
import script from "./Updated.vue?vue&type=script&lang=ts&"
export * from "./Updated.vue?vue&type=script&lang=ts&"
import style0 from "./Updated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports